<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.cons{
  display: none;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
  .area{
    li{
      width:25%;
    }
  }
  @media screen and (max-width: 640px){
    .area li {
      width: 30% !important;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_15.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>人全基因组测序</h1>-->
<!--          <h2 class="mt10">Human genome sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>人全基因组测序</h1>
      <h2 class="mt10">Human Genome Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">人全基因组测序（Whole Genome Sequencing，WGS）是利用高通量测序平台对一种生物的基因组中的全部基因进行测序，测定其 DNA 的碱基序列。基于全基因组重测序的人类遗传学和群体进化学的研究可在全基因组水平上检测单核苷酸变异 (SNV)、插入缺失 (InDel)、拷贝数变异 (CNV) 和结构变异 (SV) 等多种全面的突变信息。全基因组重测序已成为人类遗传学、转化医学和群体进化领域快速而有效的方法之一，在全基因组水平上扫描并检测与表型差异、疾病、进化等相关的突变位点，具有重大的科研价值。</p>
      <div class="c-title">应用领域</div>
      <div  class="con">
        <ul class="lists area ">
          <li>
            <img src="@/assets/images/prokaryotic_icon_1.png">
            <p>变异位点</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_1.png">
            <p>基因检测</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_9.png">
            <p>单基因病</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_2.png">
            <p>复杂疾病</p>
          </li>
          <li>
            <img src="@/assets/images/target_icon_3.png">
            <p>肿瘤研究</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_3.png">
            <p>群体研究</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_4.png">
            <p>动植物育种</p>
          </li>
          <li>
            <img src="@/assets/images/resequencing_icon_5.png">
            <p>更多</p>
          </li>
        </ul>
      </div>
      <div  class="cons" style="margin-top: 20px;">
        <ul class="lists area ">
          <li>
            <img src="@/assets/images/prokaryotic_icon_1.png">
            <p>变异位点</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_1.png">
            <p>基因检测</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_9.png">
            <p>单基因病</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_2.png">
            <p>复杂疾病</p>
          </li>
          <li>
            <img src="@/assets/images/target_icon_3.png">
            <p>肿瘤研究</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_3.png">
            <p>群体研究</p>
          </li>
          <li>
            <img src="@/assets/images/human_icon_4.png">
            <p>动植物育种</p>
          </li>
          <li>
            <img src="@/assets/images/resequencing_icon_5.png">
            <p>更多</p>
          </li>
        </ul>
      </div>
      <div class="c-title">技术参数</div>
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>HiSeq/Novaseq PE150DNBSEQ T7 PE150</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_5.png">
          <h4>项目周期</h4>
          <p>30天</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>90G(30×)</p>
        </li> -->
        <li>
          <img src="@/assets/images/target_icon_5.png">
          <h4>捕获试剂盒</h4>
          <p>定制探针</p>
        </li>
        <li>
          <img src="@/assets/images/human_icon_5.png">
          <h4>DNA质检要求</h4>
          <p>浓度> 30 ng/μL</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png">
          <h4>数据质量</h4>
          <p>0.2X均一性：> 97% 覆盖度：> 99%</p>
        </li>
      </ul>
      <div class="c-title">项目流程</div>
      <div class="tc con"><img src="@/assets/images/human_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/human_1.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/human_sequencing.vue